import { CenterCenter } from '@mosanic/styles';
import Image from 'next/image';
import styled from 'styled-components';


const EmptyContainer = styled.div` 
    ${CenterCenter}
    text-align: center;
    min-height: calc(100vh - 300px);

    * > :not(h1, h2, h3, h4, h5, h6) * {
        font-size: ${props => props.fontSize};
    }
`;

const Img = styled(Image)` 
    filter: grayscale(1);
    opacity: ${props => props.opacity};
`

const emptyLayers = "Once dropped, you can view the layers here.";

export const EmptyLayout = ({width = "275px", height="150px", fontSize = '12px', opacity = 0.3, help = emptyLayers, children}) => (
    <>
    <EmptyContainer fontSize={fontSize}>
        {children ? children : (
            <>
                Drop your first item in the canvas. <br/>
                {help}  
            </>
        )}
    </EmptyContainer>
    <Img width={width} height={height} opacity={opacity} alt="empty canvas" src="/floor-empty.jpeg" />
    </>
)